var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8B5EB882-E236-4C55-9890-7143BFBAC886") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empresas",
    transform: "translate(-600.000000, -2471.000000)",
    fill: "#B0BEC5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(600.000000, 2471.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8640261,0 C18.0118869,0 18.9465088,0.934894405 18.9465088,2.08308996 L18.9465088,2.08308996 L18.9465088,11.6187542 C18.9465088,11.9273601 18.6969738,12.1769679 18.3884579,12.1769679 C18.0799419,12.1769679 17.830407,11.9273601 17.830407,11.6187542 L17.830407,11.6187542 L17.830407,2.08308996 C17.830407,1.95601693 17.803185,1.83802055 17.757815,1.72456249 L17.757815,1.72456249 L9.78630734,8.64550409 C9.68195635,8.73627053 9.55492038,8.78165376 9.4233474,8.78165376 C9.29631142,8.78165376 9.16473844,8.73627053 9.06038746,8.64550409 L9.06038746,8.64550409 L1.1614718,1.78356069 C1.13424981,1.87886545 1.11156481,1.97870855 1.11156481,2.08308996 L1.11156481,2.08308996 L1.11156481,12.3124685 C1.11156481,12.9478337 1.62878272,13.4606641 2.25942562,13.4606641 L2.25942562,13.4606641 L17.2723561,13.4606641 C17.580872,13.4606641 17.830407,13.7102718 17.830407,14.0188778 C17.830407,14.3274837 17.580872,14.5770914 17.2723561,14.5770914 L17.2723561,14.5770914 L2.25942562,14.5770914 C1.01175083,14.5770914 0,13.5605072 0,12.3170069 L0,12.3170069 L0,2.08308996 C0,1.47041644 0.267682954,0.921279438 0.689623883,0.54006036 C0.70323488,0.530983716 0.712308879,0.521907071 0.721382877,0.512830426 C1.08434282,0.195147861 1.56072773,0 2.08248265,0 L2.08248265,0 Z M16.7687491,1.11188898 L2.08248265,1.11188898 L9.4278844,7.48823189 L16.7687491,1.11188898 Z",
    id: "Combined-Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1d4f2e73.svg";
export { ForwardRef as ReactComponent };